<div class="receipt-detail">
    <!-- Explains the red indicator: this order needs a full tax invoice
         (ใบกำกับภาษี), not just a receipt. -->
    @if (detail.taxInvoiceRequested) {
    <div class="rd-doctype">ใบกำกับภาษี · Tax invoice requested</div>
    } @if (detail.name) {
    <div class="rd-name">{{ detail.name }}</div>
    } @if (detail.taxId) {
    <div class="rd-line">
        <span class="rd-label">Tax ID</span>
        <span class="rd-taxid">{{ detail.taxId }}</span>
    </div>
    } @if (detail.branch) {
    <div class="rd-line">
        <span class="rd-label">Branch</span>
        <span>{{ detail.branch }}</span>
    </div>
    } @if (detail.address) {
    <div class="rd-address">{{ detail.address }}</div>
    }
    <!-- Green when the customer gave us these details, amber when they were
         worked out from the order and want checking before printing. -->
    <div
        class="rd-source"
        [class.rd-inferred]="detail.confidence === 'inferred'"
    >
        <span class="rd-source-kind">{{
            detail.confidence === 'inferred' ? 'Inferred' : 'Customer-stated'
        }}</span>
        <span class="rd-source-from">{{ detail.source }}</span>
    </div>
</div>
